import IEmittedEvent from "./IEmittedEvent";
import { EVENT_TYPES } from "../types/EventTypes";
import DIALOGBOX_EVENT_TYPES from "./DialogBoxEventTypes";

// TODO: Refactor DialogEvents to support more than a single event type from the same interface
// the actual eventType (yesorNo, clickToContinue) should be based off a property from the interface,
// and defined on each class
interface IDialogBoxEvent {
  header?: string;
  message: string;
  labels: { yes: string; no: string };
  callback: Function;
  callbackCalled: boolean;
  type: DIALOGBOX_EVENT_TYPES;
}
interface IDialogBoxYesNoEvent extends IDialogBoxEvent {}

/**
 * If the user clicks the 'Yes' button, the callback will be called with _true_
 * Otherwiser, the callback will be called with _false_
 */
// TODO: type support for callback arguments
class DialogBoxYesNoEvent implements IEmittedEvent {
  message: string;
  header: string;
  labels: { yes: string; no: string };
  val: IDialogBoxYesNoEvent;
  wrappedCallback: Function;
  /**
   * This function is called by the Dialog box. This wraps the
   * original callback to call, to handle exceptions and wrap in a promise.
   * why a promise ? you might want to know when the function that called our callback has returned ?
   * it's just kind of here
   */
  callback: Function;

  readonly name: DIALOGBOX_EVENT_TYPES = "DB_yesNoQuery";
  constructor(
    message: string,
    callback: Function,
    buttonLabels: { yes: string; no: string } = { yes: "Yes", no: "No" },
    header: string = "Error",
  ) {
    this.message = message;
    this.labels = buttonLabels;
    this.header = header;
    this.wrappedCallback = callback;
    this.callback = async (args: any) => {
      try {
        this.wrappedCallback(args);
      } catch (e) {
        console.log(e);
      }
    };
    this.val = {
      header: this.header,
      message,
      labels: this.labels,
      callback: this.callback,
      callbackCalled: false,
      type: this.name,
    };
  }
}

interface IDialogBoxConfirmEvent extends IDialogBoxEvent {}
/**
 * If the user clicks the 'Yes' button, the callback will be called with _true_
 * Otherwiser, the callback will be called with _false_
 */
class DialogBoxConfirmEvent implements IEmittedEvent {
  header: string;
  message: string;
  val: IDialogBoxConfirmEvent;
  wrappedCallback: Function;
  /**
   * This function is called by the Dialog box. This wraps the
   * original callback to call, to handle exceptions and wrap in a promise.
   * why a promise ? you might want to know when the function that called our callback has returned ?
   * it's just kind of here
   */
  callback: Function;

  readonly name: DIALOGBOX_EVENT_TYPES = "DB_confirm";
  constructor(message: string, callback: Function, header: string = "Error") {
    this.message = message;
    this.header = header;
    this.wrappedCallback = callback;
    this.callback = async (args: any) => {
      try {
        this.wrappedCallback(args);
      } catch (e) {
        console.log(e);
      }
    };
    this.val = {
      labels: { yes: "Yes", no: "No" },
      message,
      header,
      callback: this.callback,
      callbackCalled: false,
      type: this.name,
    };
  }
}

interface IDialogBoxWaitingEvent extends IDialogBoxEvent {
  waitingOn: Promise<any>;
}
/**
 * If the user clicks the 'Yes' button, the callback will be called with _true_
 * Otherwiser, the callback will be called with _false_
 */
class DialogBoxWaitingEvent implements IEmittedEvent {
  message: string;
  val: IDialogBoxWaitingEvent;
  header: string;
  wrappedCallback: Function;
  /**
   * This function is called by the Dialog box. This wraps the
   * original callback to call, to handle exceptions and wrap in a promise.
   * why a promise ? you might want to know when the function that called our callback has returned ?
   * it's just kind of here
   */
  callback: Function;

  readonly name: DIALOGBOX_EVENT_TYPES = "DB_waiting";
  constructor(
    message: string,
    callback: Function,
    waitingOn: Promise<any>,
    header: string = "Please Wait",
  ) {
    this.message = message;
    this.wrappedCallback = callback;
    this.header = header;
    this.callback = async (args: any) => {
      try {
        this.wrappedCallback(args);
      } catch (e) {
        console.log(e);
      }
    };
    this.val = {
      waitingOn: waitingOn,
      labels: { yes: "Yes", no: "No" },
      message,
      header: this.header,
      callback: this.callback,
      callbackCalled: false,
      type: this.name,
    };
  }
}

export { IDialogBoxEvent };
export { IDialogBoxYesNoEvent, DialogBoxYesNoEvent };
export { IDialogBoxConfirmEvent, DialogBoxConfirmEvent };
export { IDialogBoxWaitingEvent, DialogBoxWaitingEvent };
